import React, { useState } from "react";
import "./login.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState(false); // สำหรับเก็บสถานะการ login ไม่ผ่าน
  const [passwordError, setPasswordError] = useState(false); // สำหรับเก็บสถานะการแจ้งเตือน password เป็น request field
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!password) {
      setPasswordError(true); // ตั้งค่าแจ้งเตือน password เป็น request field
      return;
    }

    try {
      const response = await axios.post(
        "https://z5v86id0wa.execute-api.us-west-2.amazonaws.com/dev/togetherplace/login",
        { username: username, password: password }
      );
      if (response.data.length > 0) {
        // Simulate login
        onLogin(true);
        navigate("/home"); // Redirect to /home after successful login
      } else {
        setLoginError(true); // ตั้งค่าแจ้งเตือน error ถ้า login ไม่ผ่าน
      }
    } catch (error) {
      console.error("Error making POST request", error);
      setLoginError(true); // ตั้งค่าแจ้งเตือน error ถ้าเกิดข้อผิดพลาดใน POST request
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          setPasswordError(false); // รีเซ็ตแจ้งเตือน password เมื่อผู้ใช้กรอกข้อมูล
        }}
      />
      {passwordError && (
        <div className="error-popup">
          Password is required.
        </div>
      )}
      <button onClick={handleLogin}>Login</button>
      {loginError && (
        <div className="error-popup">
          Login failed. Please try again.
        </div>
      )}
    </div>
  );
}

export default Login;
